<template>
    <div>
        <Wp_card_sku style="margin-left: 5%; margin-right: 5%">
            <div slot="left">
                <img :src="skuInfo.imageInfo.imageList[0].url" width="98%"/>
            </div>
            <div slot="right" style="margin-left: 2%">
                <div class="sku_title">
                    <h3>{{skuInfo.skuName}}</h3>
                </div>
<!--                <div style="color:red" class="sku_price">-->
<!--                    <Row>-->
<!--                        <i-col span="12">-->
<!--                            &lt;!&ndash;                            佣金:{{skuInfo.commissionInfo.commission}}&ndash;&gt;-->
<!--                            123预估佣金:￥{{commission}}-->
<!--                        </i-col>-->
<!--                        <i-col span="12">-->
<!--                            &lt;!&ndash;                            佣金比例:{{skuInfo.commissionInfo.commissionShare}}%&ndash;&gt;-->
<!--                            123佣金比例:{{commissionShare}}%-->
<!--                        </i-col>-->
<!--                    </Row>-->
<!--                </div>-->

                <div class="sku_price">
                    <Row>
                        <i-col span="15" style="color:red">
                            <span v-if="couponData && couponData.discount && skuInfo.priceInfo.lowestCouponPrice">
                                    <span>内购价:¥{{(skuInfo.priceInfo.lowestCouponPrice).toFixed(2)}}
                                        <span style="font-size:10px;color:gray;text-decoration:line-through;">
                                            ¥{{skuInfo.priceInfo.lowestPrice}}
                                        </span>
                                    </span>
                            </span>
                            <span v-else>
                                内购价:¥{{skuInfo.priceInfo.lowestPrice}}
                            </span>
                        </i-col>
                        <i-col span="9">
                            <div class="sku_month">
                                月销:{{skuInfo.inOrderCount30Days}}
                            </div>
                        </i-col>
                    </Row>
                    <Row>
                        <span v-if="skuInfo.pinGouInfo.pingouPrice" style="color:red">
                                <Icon type="ios-contacts" size="20"/>
                                {{skuInfo.pinGouInfo.pingouTmCount}}人拼
                        </span>
                        <span v-else>
                            &nbsp;
                        </span>
                    </Row>
                </div>

                <div class="sku_tags">
                    <div style="float:left;" v-if="skuInfo.owner==='g'">
                        <van-tag color="red" plain>自营</van-tag>
                    </div>
                    <div style="float:left;" v-if="skuInfo.isHot===1">
                        <van-tag color="red" plain>爆品</van-tag>
                    </div>
                    <div style="float:left;" v-if="couponData && couponData.discount">

                        <JdCouponBar :couponData="couponData"></JdCouponBar>
                    </div>
                </div>
            </div>
            <div slot="bottom">
                <div style="text-align: center;margin-top: 10px">
                    <van-button plain round
                                style="width: 110px;"
                                type="danger"
                                size="small"
                                icon="shopping-cart-o"
                                v-on:click="buyGoods"
                    >立即购买
                    </van-button>
                    &nbsp;
                    <van-button plain round
                                style="width: 110px; color: orange; border-color: orange"
                                size="small"
                                icon="share"
                                v-on:click="makeLinks"
                    >分享给朋友
                    </van-button>
                </div>
            </div>
        </Wp_card_sku>
        <Divider dashed style="padding-left: 10px;padding-right: 10px; margin-top: 20px"></Divider>
        <van-action-sheet
                title="推广详情"
                v-model="showLink"
                @close="sheetClosed"
                style="padding-bottom: 20px"
        >

            <div style="padding: 20px">
                <Alert type="warning">转发步骤:1.长按保存图片,2.点击复制文案。</Alert>
                <div style="text-align: center" v-if="imageList.length > 0">
<!--                    <img :src="skuInfo.imageInfo.imageList[0].url" width="50%"/>-->
                    <van-swipe @change="onSwipeChange">
                        <van-swipe-item v-for="(image, index) in imageList" :key="index">
                            <img :src="image.url" width="50%"/>
                        </van-swipe-item>
                        <div class="custom-indicator" slot="indicator">
                            {{ currentIndex + 1 }}/{{imageList.length}}
                        </div>
                    </van-swipe>
                </div>
                <div>
                    <van-field
                            v-model="linkContent"
                            type="textarea"
                            rows="10"
                            autosize
                    ></van-field>
                </div>
                <div style="text-align: center;margin-top: 15px">
                    <van-button v-if="newLink" plain type="info"
                                style="margin-left: 10px"
                                v-clipboard:copy="linkContent.replace(new RegExp('<br/>','gm'),'\n')"
                                v-clipboard:success="onCopySuccess"
                                v-clipboard:error="onError"
                    >复制文案
                    </van-button>
                </div>
            </div>


            <van-button id="stamp_button" ref="stamp_button" type="danger" plain
                        style="width: auto; height: auto; z-index:1;border-radius: 3px;
                        padding-left: 5px; padding-right:5px; padding-top: 5px; padding-bottom: 5px;
                        display: none;position: absolute;right:10%;bottom:42%; background-color: #ffffff77;
                        transform: rotate(25deg)"
            >
                <van-button type="danger" plain hairline
                            style="width:100%; height: 100%;border-radius: 3px;background-color: #ffffff77; "
                ><h3>复制成功</h3>
                </van-button>
            </van-button>

            <!--            <div style="width: auto; height: auto; z-index:1;-->
            <!--                        border-radius: 3px; border: 2px;border-color: red; border-style: solid;-->
            <!--                        padding-left: 5px; padding-right:5px; padding-top: 5px; padding-bottom: 5px;-->
            <!--                        display: block;position: fixed;right:10%;bottom:22%; background-color: #99999900"-->
            <!--                 :style="iconstyle"-->
            <!--            >-->
            <!--                <div style="width:100%; height: 100%;-->
            <!--                border-radius: 3px;border: 2px;border-color: red; border-style: solid;-->
            <!--                padding-left: 10px; padding-right:10px; padding-top: 5px; padding-bottom: 5px;-->
            <!--                background-color: #ffffff00"-->
            <!--                ><h2 style="color: red">复制成功</h2>-->
            <!--                </div>-->
            <!--            </div>-->

        </van-action-sheet>
    </div>
</template>

<script>
    import Vue from 'vue';
    import {Row, Col, Tag, Icon, Button, Divider, Alert} from 'iview';
    import JdCouponBar from "@/components/custom/JdCouponBar";
    import Wp_card_sku from "@/components/custom/Wp_card_sku";
    import {Toast} from "vant";

    Vue.component('Divider', Divider);
    Vue.component('Row', Row);
    Vue.component('i-col', Col);
    Vue.component('Tag', Tag);
    Vue.component('Icon', Icon);
    Vue.component('i-button', Button);
    Vue.component('Alert', Alert);


    export default {
        name: "JdSkuInfoCard_ForUser",
        components: {Wp_card_sku, JdCouponBar},
        props: {
            skuInfo: {type: Object, default: null},
            // couponData: {type: Object, default: null},
            width: {type: String, default: '90%'},
            position_id:{
                type:String,
                default:''
            },
        },
        data() {
            return {
                couponData: {},
                //实际金额
                actual_cost: 0,
                //佣金金额
                commission: 0,
                //佣金比例
                commissionShare: 0,

                newLink: '',
                linkContent: '',
                showLink: false,

                imageList: [],
                //swipe当前的index
                currentIndex: 0,

            }
        },
        created() {
            if (this.skuInfo) {
                this.findCoupon();
                //佣金比例，除以2，平分，0.9是订单返回数据中的finalRate最终比例
                this.commissionShare = this.skuInfo.commissionInfo.commissionShare * 0.9 / 2;
                if(this.commissionShare.toString().indexOf(".") > 0){
                    this.commissionShare = (this.commissionShare).toFixed(2);
                }

                if (this.couponData && this.couponData.discount) {
                    //如果包含优惠券，佣金金额=(最低金额-优惠券金额) * 佣金比例 / 2 / 100，取小数点后两位，（除以2是平分实际佣金）
                    this.commission = ((this.skuInfo.priceInfo.lowestPrice - this.couponData.discount) * (this.commissionShare / 100));
                } else {
                    this.commission = (this.skuInfo.commissionInfo.commission / 2);
                }
                //取两位小数
                this.commission = (this.commission).toFixed(2);
            }
        },
        // computed: {
        //     /**
        //      * 动态旋转
        //      * @return {string}
        //      */
        //     iconstyle() {
        //         let arr = new Array();
        //         arr.push('transform:');
        //         arr.push('rotate(' + 30 + 'deg) ');
        //         return arr.join("");
        //
        //     }
        // },
        methods: {
            /**
             * swipe滚动监听
             */
            onSwipeChange(index) {
                this.currentIndex = index;
            },
            /**
             * 查找优惠券
             */
            findCoupon() {
                let couponList = this.skuInfo.couponInfo.couponList;
                let _couponData = this.$common.autoFindCoupon2(couponList);
                if (_couponData) {
                    this.couponData = _couponData;
                }
            },

            buyGoods(){
                let _skuId = this.skuInfo.skuId;
                if (_skuId) {
                    let _data = this.getUrlParams(_skuId);

                    let that = this;
                    this.$getUnionLink(_data, function (response) {
                        let code = response.code;
                        // let message = response.message;
                        if (code === 200) {
                            let shortURL = response.data.shortURL;
                            that.newLink = shortURL;

                            // that.$get(that.newLink);
                            location.href = that.newLink;
                        }
                    })
                }
            },


            makeLinks() {
                let _skuId = this.skuInfo.skuId;
                if (_skuId) {
                    let _data = this.getUrlParams(_skuId);

                    let that = this;
                    this.$getUnionLink(_data, function (response) {
                        let code = response.code;
                        // let message = response.message;
                        if (code === 200) {
                            let shortURL = response.data.shortURL;
                            that.newLink = shortURL;

                            that.getLinkContent(shortURL);

                            //使用setTimeout避免ActionSheet使用了Swipe弹出时，会先跟着半透明蒙板变暗，然后再完全展现
                            setTimeout(()=>{
                                that.imageList = that.skuInfo.imageInfo.imageList;
                            });

                            //打开复制文案弹窗
                            that.showLink = true;
                        }else{
                            // Dialog.alert({
                            //     message: "添加失败，商品活动已过期"
                            // });
                            Toast({
                                duration: 1000,
                                message:"添加失败\n商品活动已过期"
                            })
                        }
                    })
                }
            },

            /**
             * 获取请求url所需的参数，json格式
             */
            getUrlParams(skuId){
                let mediaId = this.$common.mediaId_70637;
                let _materialId = 'https://wqitem.jd.com/item/view?sku=' + skuId;
                let _couponUrl = '';
                if(this.couponData && this.couponData.discount && typeof (this.couponData.discount) !== 'undefined' && this.skuInfo.priceInfo.lowestCouponPrice){
                    _couponUrl = this.couponData.link;
                }

                let _positionId = this.$common.getPid();

                if(this.position_id){
                    _positionId = this.position_id;
                }else{
                    this.$toast.fail({
                        message: '数据异常',
                    });
                    return;
                }

                // let _positionId = '1825325610';

                let _data = {
                    app_key: this.$common.getAppKeyInfo(mediaId).app_key,
                    app_secret: this.$common.getAppKeyInfo(mediaId).app_secret,
                    materialId: _materialId,
                    subUnionId: '',
                    positionId: _positionId, //推广位ID
                    // pid: _pid,
                    couponUrl: _couponUrl,
                    chainType: 2,
                };
                return _data;
            },

            /**
             * 显示"复制成功"的图章
             */
            showStamp() {
                this.$log("showStamp")
                // let stampButton = document.getElementById('stamp_button');
                // stampButton.style.display = 'block';
                //展示"复制成功"图章
                this.$refs.stamp_button.style.display = 'block';
            },
            /**
             * sheet上拉模板关闭时回调
             */
            sheetClosed() {
                // let stampButton = document.getElementById('stamp_button');
                // stampButton.style.display = 'none';
                //删除"复制成功"图章
                this.$refs.stamp_button.style.display = 'none';
                //swipe所要加载的图片集合重置
                this.imageList = [];
                //swipe的indicator角标重置
                this.currentIndex = 0;
            },
            onCopySuccess() {
                this.showStamp();
                setTimeout(() => {
                    // this.showLink = false;
                    // this.$toast.success({
                    //     message: '复制成功',
                    //     duration: 1000
                    // });
                    this.$notify({
                        message: '\n复制成功\n ',
                        duration: 2000,
                        background: '#1989fa'
                    });

                }, 500);
            },
            onError() {
                // this.$toast.error({
                //     message: '复制失败',
                //     duration: 1000
                // });
                setTimeout(() => {
                    this.$notify({
                        message: '\n复制失败\n ',
                        duration: 2000,
                    });
                }, 500);
            },
            getLinkContent(newLink) {
                let content = '' + this.skuInfo.skuName + '\n\n' +
                    '————————\n' +
                    '京东价:¥ ' + this.skuInfo.priceInfo.lowestPrice + '\n' +
                    '内购价:¥ ¥' + (this.skuInfo.priceInfo.lowestPrice - this.couponData.discount).toFixed(2) + '\n' +
                    '————————\n' +
                    '领券 + 下单：' + newLink + '\n' +
                    '【会员专享 · 京东保障】\n';
                this.linkContent = content;
            }
        }
    }
</script>

<style scoped>
    .sku_info {
        font-size: 12px;
        text-align: left;
        margin: 5px;
    }

    .sku_title {
        /*height: 45px;*/
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

    .sku_price {
        font-size: 14px;
    }

    .sku_month {
        font-size: 12px;
        text-align: right;
    }

    .sku_tags {
        display: inline-block;
    }

    /*.van-popup--bottom {*/
    /*    border-radius: 12px 12px 0 0;*/
    /*}*/

    .custom-indicator {
        position: absolute;
        right: 5px;
        bottom: 5px;
        padding: 1px 7px;
        color: #fff;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.3);
    }

</style>